var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9446 14.0695C17.7366 14.0695 20 11.8154 20 9.03475C20 6.25413 17.7366 4 14.9446 4C12.1526 4 9.8892 6.25413 9.8892 9.03475C9.8892 10.3227 10.477 11.2594 10.477 11.2594L4.36352 17.3479C4.0892 17.6211 3.70515 18.3315 4.36352 18.9872L5.06893 19.6897C5.34324 19.9239 6.03295 20.2517 6.59728 19.6897L7.42025 18.8701C8.24322 19.6897 9.18376 19.2213 9.53646 18.753C10.1243 17.9334 9.4189 17.1138 9.4189 17.1138L9.65403 16.8796C10.7827 18.0036 11.7702 17.3479 12.1229 16.8796C12.7108 16.06 12.1229 15.2404 12.1229 15.2404C11.8878 14.772 11.4176 14.772 12.0054 14.1866L12.7108 13.4841C13.2751 13.9524 14.4351 14.0695 14.9446 14.0695Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.a560c12794cecf826809ea471326472a.svg";
export { ForwardRef as ReactComponent };